import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Zap, Shield, TrendingUp, Users, Target, Award, ArrowRight } from 'lucide-react';
import ContactLink from '@/components/ContactLink';

const WhyChooseAKIVA = () => {
  const reasons = [
    {
      icon: Target,
      title: 'Solutions',
      description: 'We deliver AI engineering and enterprise services for commercial enterprises and government agencies. From program management to AI/ML engineering and supply chain optimization, we bring AI-enabled capabilities across the full spectrum of enterprise operations.'
    },
    {
      icon: Shield,
      title: 'Experience',
      description: 'Our team brings experience from government and commercial sectors, with backgrounds in complex system deployments and program management. We understand the requirements of high-stakes environments and compliance-driven projects.'
    },
    {
      icon: Zap,
      title: 'Innovation',
      description: 'We build solutions designed to scale with industry and customer requirements. Our team pioneers new approaches, from multi-agent frameworks to agentic AI architectures, turning emerging technology into production-ready systems that drive real results.'
    },
    {
      icon: TrendingUp,
      title: 'Impact',
      description: 'We prioritize measurable outcomes including efficiency improvements, cost optimization, and strategic value. Our solutions aim to deliver tangible business benefits through intelligent automation, analytics, and process optimization.'
    },
    {
      icon: Award,
      title: 'Compliance',
      description: 'We maintain industry-recognized certifications and adhere to federal security standards. Our commitment to compliance helps ensure quality and security in our delivery processes and client engagements.'
    },
    {
      icon: Users,
      title: 'Partnership',
      description: 'As a Veteran-led small business, we bring disciplined execution and reliable delivery to every engagement. We build long-term partnerships through consistent results and technical excellence.'
    }
  ];

  return (
    <section className="section-padding bg-background relative overflow-hidden">
      <div className="container-max relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 tracking-tight text-primary">
            Why Choose Us
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
            Transforming complex challenges into measurable results through AI innovation and enterprise expertise
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {reasons.map((reason) => (
            <Card key={reason.title} className="flex flex-col border-border/50 bg-card/50 p-6 transition-colors duration-150 ease-out hover:bg-muted/40">
              <div className="mb-5 flex h-10 w-10 items-center justify-center rounded-md bg-primary/10 dark:bg-primary/15">
                <reason.icon className="h-5 w-5 text-primary" strokeWidth={1.75} aria-hidden="true" />
              </div>
              <h3 className="mb-3 text-lg font-semibold leading-tight text-foreground">{reason.title}</h3>
              <p className="text-sm leading-relaxed text-muted-foreground">{reason.description}</p>
            </Card>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <Button size="lg" className="group" asChild>
            <ContactLink>
              Schedule a Consultation
              <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
            </ContactLink>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseAKIVA;
